import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allRondasAction,
  deleteRondasAction,
  setActivoRondasAction,
} from '../RondasAction';
import { PARAMS_RONDAS } from '../RondasReducer';
import ExpandedRondasComponent from './ExpandedRondas';

const ListadoRondas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const rondasStore = Redux.useSelector((state) => state.rondas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...rondasStore.params,
        idTorneo: torneosStore.activo.id,
      };
      dispatch({ type: PARAMS_RONDAS, payload });
      await allRondasAction(dispatch, payload);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    rondasStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [rondasStore.all]);

  const _handleEditClick = async (id) => {
    const data = rondasStore.all.find((el) => el.id === id);
    await setActivoRondasAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteRondasAction(
      { dispatch, notify },
      rondasStore.activo.id,
      rondasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return rondasStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.posicion.name,
      label: CONST.posicion.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setActivoRondasAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = rondasStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedRondasComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={rondasStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {rondasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{rondasStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoRondas;
